import React from "react";
import logo from "../assets/paramarshLogoHead.png";
// import logo from "../assets/indianOil.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faUser,
  faBell,
  faMoon,
  faSignOut
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logoutUser } from "../Redux/userSlice";

export default function Header({
  handleSidebarToggle,
  sidebarStatus,
  userName,
  userType,
  emailVerifFlag = true
}) {
  const handleSidebar = () => {
    handleSidebarToggle(!sidebarStatus);
  };
  const dispatch = useDispatch();


  const handleLogout = () => {
    // localStorage.removeItem('userDetails');
    // localStorage.removeItem('formLocalData');
    // localStorage.removeItem('productInfo');
    // localStorage.removeItem('firebaseData');
    dispatch(logoutUser());
  };

  return (
    <header className="navbar">
      <div className="navbar-brand">
      {emailVerifFlag && 
       <span className="sidebar-toggler">
       <FontAwesomeIcon icon={faBars} onClick={() => handleSidebar()} />
     </span>
      
      
      }
       
        <Link to="/">
          {" "}
          <img src={logo} alt="" className="navbar-logo" />
         
        </Link>
      </div>
{emailVerifFlag?
  <div className="navbar-profile rounded-border-shadow">
        <h5 className="navbar-profile-title text-navyBlue">
          <FontAwesomeIcon icon={faUser} className="pr-10" />
          {userName}
           {/* ({userType}) */}
        </h5>
      </div>:<></>

}
      
      {
      <div className="navbar-right ">
      <Link to={"/"} className="navbar-links rounded-border-shadow">

     <FontAwesomeIcon icon={faSignOut} className="mr-10 text-secondary" onClick={handleLogout}  /> 
        
      </Link>
      {/* <Link to={"/"} className="navbar-links rounded-border-shadow">
        <FontAwesomeIcon icon={faBell} className="mr-10" /> 0
      </Link> */}
      {/* <Link
        to={"/"}
        className="navbar-links rounded-border-shadow"
      >
        <FontAwesomeIcon icon={faMoon} />
      </Link> */}
    </div>




      }
      
    </header>
  );
}
